import { YoutubeVideo } from "@/src/utils/youtube";
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
} from "@material-tailwind/react";
import Image from "next/image";
import Link from "next/link";
import HTMLText from "../../ui/HTMLText";

export interface VideoCardProps {
  video: YoutubeVideo;
  onClick: (id: string) => void;
}

const VideoCard = ({ video, onClick }: VideoCardProps) => {
  return (
    <Card
      className="w-[100%] h-[100%] basic-video-card rounded-none  cursor-pointer"
      onClick={() => onClick(video.id)}
    >
      <CardHeader
        className="video-card-header relative h-[250px] md:h-[144px] m-0 rounded-none"
        floated={false}
      >
        <i className="fa-solid fa-circle-play text-white bg-scpb-light-blue"></i>
        <Image src={video.thumbnail} alt={video.title} fill />
      </CardHeader>
      <div className="p-2 flex flex-col">
        <Typography variant="h6" className="mb-2">
          <HTMLText text={video.title} />
        </Typography>
      </div>
      <div className={"p-2 mt-auto"}>
        <Typography className={""}>
          {new Date(video.publishedAt).toLocaleDateString()}
        </Typography>
      </div>
    </Card>
  );
};

export default VideoCard;
